import { dropAtivo } from 'utils/drops';

const getServicosFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'ativo',
    label: 'Ativo',
    type: 'select',
    options: dropAtivo,
    defaultValue: 'SIM',
  },
  { name: 'descricao', label: 'Descrição', initial: true },
  {
    name: 'cfiscal_id',
    label: 'Código NBS',
    type: 'virtual-select',
    options: drops?.Cfiscal,
    multiple: true,
  },
  {
    name: 'servico_id',
    label: 'Código de Tributação',
    type: 'select',
    options: drops?.Servico,
    multiple: true,
  },
  { name: 'preco', label: 'Preço', type: 'currency' },
];

export default getServicosFilterFields;
